"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    var baseTags = document.getElementsByTagName('base');
    if (baseTags.length > 0) {
        return baseTags[0].href;
    }
    else {
        return '/';
    }
});
//# sourceMappingURL=context.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/utils/context.js
// module id = 2562
// module chunks = 0